import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Rss, FolderTree } from 'lucide-react';
import { isFeatureEnabled } from '../config/features';

export default function Footer() {
  const [visible, setVisible] = useState(false);
  const sentinelRef = useRef(null);

  useEffect(() => {
    const el = sentinelRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: '300px 0px', threshold: 0 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div ref={sentinelRef} />
      <footer className={`footer${visible ? ' footer-visible' : ''}`}>
        <div className="container">
          <div className="footer-grid">
            <div className="footer-brand">
              <Link to="/" className="logo" style={{ marginBottom: '6px', display: 'inline-flex' }}>
                <span className="logo-text" style={{ color: '#fff', fontSize: '1.1rem', letterSpacing: '0.06em' }}>RBXSCAMS</span>
              </Link>
              <span className="footer-tagline">Built by players, for players.</span>
              <span className="copyright">Not affiliated with Roblox Corporation.</span>
              <div className="footer-links">
                <a href="/feed.xml" target="_blank" rel="noopener noreferrer" className="footer-link footer-link-rss"><Rss size={11} />RSS Feed</a>
                <a href="/sitemap.xml" target="_blank" rel="noopener noreferrer" className="footer-link"><FolderTree size={11} />Sitemap</a>
              </div>
            </div>
            <div className="footer-col">
              <h3 className="footer-col-title" style={{ fontSize: 'inherit', fontWeight: 'inherit', margin: 0, padding: 0 }}>Content</h3>
              <Link to="/articles">Articles</Link>
              <Link to="/guides">Guides</Link>
              <Link to="/news">News</Link>
              {isFeatureEnabled('newsletter') && <Link to="/newsletter">Newsletter</Link>}
              <Link to="/quizzes">Quizzes</Link>
              <Link to="/simulations">Simulations</Link>
            </div>
            <div className="footer-col">
              <h3 className="footer-col-title" style={{ fontSize: 'inherit', fontWeight: 'inherit', margin: 0, padding: 0 }}>Community</h3>
              <Link to="/community">Community</Link>
              <Link to="/achievements">Achievements</Link>
              <Link to="/about">About</Link>
            </div>
            <div className="footer-col">
              <h3 className="footer-col-title" style={{ fontSize: 'inherit', fontWeight: 'inherit', margin: 0, padding: 0 }}>Support</h3>
              <Link to="/contact">Contact</Link>
              <Link to="/privacy">Privacy</Link>
              <Link to="/terms">Terms</Link>
              <Link to="/faq">FAQ</Link>
              <Link to="/branding">Branding</Link>
              <Link to="/accessibility">Accessibility</Link>
              <Link to="/read-later">Read Later</Link>
              <button className="footer-link-btn" onClick={() => window.dispatchEvent(new CustomEvent('reopen-cookie-settings'))}>Cookie Settings</button>
            </div>
          </div>
          <div className="footer-bottom">
            <span>2026 RbxScams — Keeping the community safe, one article at a time.</span>
          </div>
        </div>
      </footer>
    </>
  );
}
